import React, { useState } from 'react';
import { Modal, Box, Typography, Button, IconButton, CircularProgress, Snackbar, Alert } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteSweepOutlined'; // Icono de "limpieza"
import { grey, red } from '@mui/material/colors';
import BASE_URL from '../../config'

const style = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: 500 }, bgcolor: 'white', borderRadius: 4, p: 4, outline: 'none', textAlign: 'center'
};

export default function ReporteLimpiarPop({ reporte, refresh }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  const handleLimpiar = async () => {
    setLoading(true);
    try {
      // Usamos el endpoint de limpiar que definimos anteriormente
      const res = await fetch(`${BASE_URL}/reportes/${reporte.reporte_id}/limpiar`, {
        method: 'DELETE',
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setOpen(false);
        refresh(); // Recarga la lista de reportes
      } else {
        setSnackbar({ open: true, message: data.message || data.error || 'No se pudo limpiar el reporte', severity: 'error' });
      }
    } catch (e) {
      setSnackbar({ open: true, message: 'Error de conexión con el servidor', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <IconButton 
        onClick={() => setOpen(true)} 
        sx={{'&:hover': {color:grey[100], bgcolor: red[400] } }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>

      <Modal open={open} onClose={() => !loading && setOpen(false)}>
        <Box sx={style}>
          <Typography variant="h6" textAlign={'left'} mb={1}>
            ¿Deseas borrar el reporte del cliente {reporte.nombre_cliente}?
          </Typography>
          
          <Typography variant="body1" color='textSecondary' mb={3} textAlign={'left'}>
            Esta acción borrará permanentemente los campos registrados en este reporte.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'right' }}>
            <Button 
              variant="contained" 
              disabled={loading}
              sx={{ 
                color: 'black', 
                bgcolor: grey[200], 
                '&:hover': { bgcolor: grey[300] },
                textTransform: 'none', 
                px: 3 
              }} 
              onClick={() => setOpen(false)}
            >
              Cancelar
            </Button>
            
            <Button 
              variant="contained" 
              disabled={loading}
              sx={{ 
                bgcolor: red[600], 
                '&:hover': { bgcolor: red[700] }, 
                textTransform: 'none', 
                px: 3,
                minWidth: '100px'
              }} 
              onClick={handleLimpiar}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Sí, limpiar todo'}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}